import {EntityData, field, identifier} from "@fedeltapointofsale/data-client";

export class CompanyDetailsSearchData extends EntityData<CompanyDetailsSearchData> {
    @identifier companyDetailsId: number;
    @field companyName: string;
    @field ABN: string;
    @field gstNumber: string;
    @field city: string;
    @field state: string;
    @field defaultCompany: boolean;
}
